import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

const BigCTAButton = ({ destination, title, body, testid = '' }) => {
  return (
    <Link to={destination}>
      <div
        data-cy={testid}
        className='mx-auto my-5 flex w-full items-center justify-center rounded-lg bg-primary-300 p-4 text-center shadow duration-300 hover:bg-primary-700 hover:text-white lg:w-7/12  '
      >
        <div>
          <div className='text-xl font-bold'>{title}</div>
          <div className='mt-2 text-sm font-light'>{body}</div>
        </div>
      </div>
    </Link>
  );
};

BigCTAButton.propTypes = {
  destination: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
};

export default BigCTAButton;
